//////////////////////////////////////////////////////////////////
//
//  文字ハイライトアニメ
//
//////////////////////////////////////////////////////////////////

(function (document) {
  const markers = [...document.querySelectorAll('mark')];
  
  const observer = new IntersectionObserver(entries => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        entry.target.style.animationPlayState = 'running';
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.8
  });
  
  markers.forEach(mark => {
    observer.observe(mark);
  });
})(document);


//////////////////////////////////////////////////////////////////
//
//  ページメニューボタン表示 
//
//////////////////////////////////////////////////////////////////

$(document).ready(function() {
	var flag = false;
	var pagetop = $('.btn_pagenavi_block, .btn_pagenavi_block2');
	$(window).scroll(function () {
		scrollHeight = $(document).height();
		scrollPosition = $(window).height() + $(window).scrollTop();
		if (
			(scrollHeight - scrollPosition) / scrollHeight <= 0.3) {
			//スクロールの位置が下部30%の範囲に来た場合
			pagetop.addClass("slidedown");
			pagetop.removeClass("slideup");
		} else {
			//それ以外のスクロールの位置の場合
			pagetop.removeClass("slidedown");
			pagetop.addClass("slideup");
		}
	});
});

$(function () {
  setTimeout(function(){
    // メニューを半分隠す
    $(".dl-menu").css("right", "-150px");
  }, 2000);
  $(".dl-menu").hover(function() {
    // マウスが重なったときにメニューを表示する
    $(this).css("right", "0");
  });
  $(".dl-menu").mouseleave(function() {
    // マウスが離れたときにメニューを非表示にする
    $(this).css("right", "-150px");
  });
});

//////////////////////////////////////////////////////////////////
//
//  ヘッダー/フッタースクロール
//  ページトップ
//
//////////////////////////////////////////////////////////////////

$(function(){
  var pos1 = 0;
  var header = $('.header');
	var width1 = $(window).width();

	var pageheader = $('.pageheader, .pageheader2, .pagemenu');
  
  $(window).on('scroll', function(){
		
    if(width1 > 1023 && $(this).scrollTop() < pos1 && $(this).scrollTop() !== 0){
      //上スクロール時の処理
      header.addClass('fixed');
			header.addClass('dw');
			header.removeClass('up');

			// header挙動時のページメニュー動作
			pageheader.addClass('dw');
			pageheader.removeClass('up');

		} else if (width1 > 1023 && $(this).scrollTop() < pos1 && $(this).scrollTop() == 0) {
			header.removeClass('fixed');
			header.removeClass('dw');
			header.removeClass('up');

			pageheader.removeClass('dw');
			//pageheader.removeClass('up');

		} else if (width1 > 1023 && $(this).scrollTop() <! pos1 && $(this).scrollTop() == 0) {
			header.removeClass('fixed');
			header.removeClass('dw');
			header.removeClass('up');

			pageheader.removeClass('dw');
			pageheader.removeClass('up');

    }else{
      //下スクロール時の処理
			header.removeClass('dw');
			header.addClass('up');

			// header挙動時のページメニュー動作
			pageheader.removeClass('dw');
			pageheader.addClass('up');
    }
    pos1 = $(this).scrollTop();

		if(width1 < 1023){
			header.removeClass('fixed');
			header.removeClass('dw');
			header.removeClass('up');
    }
  });
});

$(function(){
	$(window).on('scroll', function(){

		const breadcrumb = $('.header-bottom');
		const scrollbc = $(window).scrollTop();
		const width = $(window).width();

		if(width > 768 && scrollbc > 50){
			breadcrumb.addClass('fixed');
		} else {
			breadcrumb.removeClass('fixed');
		}
  });
});

$(function(){
	$(window).on('scroll', function(){

		const menuLeft = $('.menu-appfilds02-lft');
		const menuRight = $('.menu-appfilds02-rgt');
		const scrollMenu = $(window).scrollTop();

		if(scrollMenu >= 4500 && scrollMenu <= 9500 ){
			menuLeft.css("left", "5px");
		} else if (scrollMenu < 4500 || scrollMenu > 9500) {
			menuLeft.css("left", "-150px");
		} else {
			menuLeft.css("left", "-150px");
		}

		if(scrollMenu >= 9500 && scrollMenu <= 15000 ){
			menuRight.css("right", "5px");
		} else if (scrollMenu < 9500 || scrollMenu > 15000) {
			menuRight.css("right", "-150px");
		} else {
			menuRight.css("right", "-150px");
		}
  });
});

$(function () {
  setTimeout(function(){
    // メニューを半分隠す
    $(".dl-menu").css("right", "-150px");
  }, 2000);
  $(".dl-menu").hover(function() {
    // マウスが重なったときにメニューを表示する
    $(this).css("right", "0");
  });
  $(".dl-menu").mouseleave(function() {
    // マウスが離れたときにメニューを非表示にする
    $(this).css("right", "-150px");
  });
});

$(function(){
  //var btn = $('.button');
	var btn = $('.btn-contact-sensor');
  var timer;
	var pos2 = 0;
	var width3 = $(window).width();

	var menufloatbtm = $('.menu-float-btm');
  
	if(width3 > 1024){
		$(window).scroll(function() {
			//スクロール開始するとボタンを非表示
			//btn.removeClass('is-active');
			btn.removeClass('up');
			btn.addClass('dw');

			menufloatbtm.removeClass('up');
			menufloatbtm.addClass('dw');
			
			//スクロール中はイベントの発火をキャンセルする
			clearTimeout(timer);
			
			//スクロールが停止して0.2秒後にイベントを発火する
			timer = setTimeout(function() {
				//スクロール位置を判定してページ上部のときはボタンを非表示にする
				if($(this).scrollTop()) {
					//btn.addClass('is-active');
					btn.removeClass('dw');
					btn.addClass('up');

					menufloatbtm.removeClass('dw');
					menufloatbtm.addClass('up');
				}else{
					//btn.removeClass('is-active');
					btn.removeClass('up');
					btn.addClass('dw');

					menufloatbtm.removeClass('up');
					menufloatbtm.addClass('dw');
				}
			}, 200);
		});
	}else{
		$(window).on('scroll', function(){
			btn.removeClass('up');
			btn.addClass('dw');

			menufloatbtm.removeClass('up');
			menufloatbtm.addClass('dw');
			clearTimeout(timer);
			timer = setTimeout(function() {
				if($(this).scrollTop() < pos2 && $(this).scrollTop() !== 0 ){
					//上にスクロール時ボタン挙動
					btn.removeClass('up');
					btn.addClass('dw');

					menufloatbtm.removeClass('up');
					menufloatbtm.addClass('dw');
				}else{
					//下にスクロール時ボタン挙動
					btn.removeClass('dw');
					btn.addClass('up');

					menufloatbtm.removeClass('dw');
					menufloatbtm.addClass('up');
				}
				pos2 = $(this).scrollTop();
			}, 200);
		});
	}
  
  //ボタンクリックでトップへ戻る
  //btn.on('click',function () {
  //  $('body,html').animate({
  //    scrollTop: 0
  //  });
  //});
});

//////////////////////////////////////////////////////////////////
//
//  スクロール途中で横スクロール
//
//////////////////////////////////////////////////////////////////

"use strict";

document.addEventListener("DOMContentLoaded", () => {
  /* horizontal scroll */
  const stickyContainers = document.querySelectorAll(".horizontal_scroll");

  stickyContainers.forEach((stickyContainer) => {
    // get elements
    const stickyItem = stickyContainer.querySelector(".sticky");
    const scroller = stickyContainer.querySelector(".scroller");
    scroller.classList.add("nobar");

    // set sticky height
    const updateStickyHeight = () => {
      const stickyHeight = scroller.scrollWidth - scroller.clientWidth + stickyItem.clientHeight;
      stickyContainer.style.setProperty("--sticky-container-height", `${stickyHeight}px`);
    };
    updateStickyHeight();
    new ResizeObserver(updateStickyHeight).observe(scroller);
    new ResizeObserver(updateStickyHeight).observe(stickyItem);

    // sync scroll
    const syncScroll = () => {
      const rect = stickyContainer.getBoundingClientRect();
      if (rect.top <= 0 && rect.bottom >= window.innerHeight) {
        scroller.scrollLeft = window.scrollY - stickyContainer.offsetTop;
      } else if (rect.bottom < window.innerHeight) {
        scroller.scrollLeft = scroller.scrollWidth - scroller.clientWidth;
      } else {
        scroller.scrollLeft = 0;
      }
    };
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener("scroll", syncScroll, { passive: true });
            syncScroll();
          } else {
            window.removeEventListener("scroll", syncScroll);
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(stickyContainer);

    // end of forEach
  });

  // end of DOMContentLoaded
});

////////////////////////////////////////////////////////
//
//  anime-trigger
//
////////////////////////////////////////////////////////

$(document).ready(function() {

	// フェードエフェクト
  scroll_effect();

  $(window).scroll(function(){
    scroll_effect();
  });

  function scroll_effect(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.fx').each(function(i){
      var elemPos = $(this).offset().top;
      var target = this;
      if (scroll > elemPos - windowHeight){
        setTimeout(function () {
          $(target).addClass("scrollin");
        }, 2 * i );
      }
    });
    $('.sldbar').each(function(i){
      var elemPos = $(this).offset().top;
      var target = this;
      if (scroll > elemPos - windowHeight){
        let delay = 100;
        $(this).delay(i * delay).queue(function(next){
          $(this).addClass('scrollin');
          next();
        })
      }
    });
  }

  // pagetop表示非表示
  var pos = 0;
	var footerMenu = $('.footer-menu');
	var width2 = $(window).width();

	if(width2 > 1024){
		$(window).on('scroll', function(){
			if($(this).scrollTop() < pos && $(this).scrollTop() !== 0 ){
				footerMenu.removeClass('up');
				footerMenu.addClass('dw');
			}else{
				footerMenu.removeClass('dw');
				footerMenu.addClass('up');
			}
			pos = $(this).scrollTop();
		});
	}else{
		$(window).on('scroll', function(){
			if($(this).scrollTop() < pos && $(this).scrollTop() !== 0 ){
				footerMenu.removeClass('dw');
				footerMenu.addClass('up');
			}else{
				footerMenu.removeClass('up');
				footerMenu.addClass('dw');
			}
			pos = $(this).scrollTop();
		});
	}
});